import { render, staticRenderFns } from "./PrivacyCollection_202609.vue?vue&type=template&id=722721d5&scoped=true"
import script from "./PrivacyCollection_202609.vue?vue&type=script&lang=js"
export * from "./PrivacyCollection_202609.vue?vue&type=script&lang=js"
import style0 from "@/assets/help/document.css?vue&type=style&index=0&id=722721d5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722721d5",
  null
  
)

export default component.exports